var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 6.66797L7.99935 12.0013H2.66602V20.0013H7.99935L14.666 25.3346L14.666 6.66797Z",
    stroke: "white",
    strokeWidth: 2.94388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4254 6.57422C27.925 9.07459 29.3292 12.4654 29.3292 16.0009C29.3292 19.5364 27.925 22.9272 25.4254 25.4276M20.7188 11.2809C21.9686 12.5311 22.6707 14.2265 22.6707 15.9942C22.6707 17.762 21.9686 19.4574 20.7188 20.7076",
    stroke: "white",
    strokeWidth: 2.94388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume2);
export default __webpack_public_path__ + "static/media/volume-2.8def07ba139e4aa5fb77ecc857a79c69.svg";
export { ForwardRef as ReactComponent };